class AsideWithContent extends ViewBasic {
    constructor(options) {
        super(options);
    }

    init(){
        this.previousScroll = 0;
        this.$sideMenu = this.$('.side-menu');

        //prevent js error when no aside menu is visible in the restaurant (only a pdf button to download the menu)
        if(this.$sideMenu.length == 0){return;}

        this.$listItemDesktop = this.$sideMenu.find('li');
        this.$asideContent = this.$('.aside-related-content');
        this.$sidemenuSection = this.$('.side-menu-section');

        this.$header = $('.header');
        this.$navigationHeader = $('.main-navigation');
        this.$menuCategory = $('.menu-category');

        this.$select = this.$('#sideMenu');

        this.$menuOffset = this.$sideMenu.offset().top;

        if(location.hash) {
            // Active category from the hash in th URL
            this.goToHash();

            this.$selectOptions = this.$('#sideMenu option');
            this.$selectOptions.each(function (index, element) {
                $(element).removeAttr('data-default');
                $(element).removeAttr('selected');

                if (this.value === location.hash) {
                    $(element).attr('data-default', '');
                    $(element).attr('selected', 'selected');
                }
            });
        }

        this.skin = new Me.skin(this.$('.side-menu-mobile'));

        this.addEvents();
    }

    addEvents() {
        Me.dispatch.subscribe('breakpointChanged', (e, params) => this.handleBreakpoints(e, params));
        Me.dispatch.subscribe('scrollToAnchor',  e => this.goToHash(e));
        Me.dispatch.subscribe('MobileMenu.changeState', (e, params) => this.changeMobileMenuState(e, params));
        $(window).scroll( e => this.scrollHandler(e));
        $(window).on('hashchange', e => this.goToHash(e));
        this.$select.on('change', e => this.changeHash(e));
    }

    removeEvents() {
        Me.dispatch.unsubscribe('breakpointChanged', (e, params) => this.handleBreakpoints(e, params));
        $(window).off('hashchange', e => this.goToHash(e));
    }

    changeHash(e){
        window.location.hash = e.currentTarget.value;

        this.goToHash(e);
    }

    goToHash(e){
        // console.log(typeof e)
        if(e && typeof e == 'event'){
            e.preventDefault();
        }

        let selectedMenu = location.hash;

        this.changeActive(selectedMenu);
    }

    changeActive(selectedMenu) {
        //Remove class Active
        this.$listItemDesktop.each(function() {
            $(this).removeClass('active');
        });

        //Add class Active
        this.$('a[href="'+selectedMenu+'"]').parent().addClass('active');

        //reset side menu to top to make sure the menu doesn't stick too far when switching from a big section to a smaller one
        this.$sideMenu.css({'top': 0});

        Me.dispatch.emit('asideContent.change', this, {'activeHash': selectedMenu.replace('#','')});
    }

    scrollHandler() {
        //Variables
        this.$headerHeight = this.$header.height();
        this.$menuCategoryHeight = this.$menuCategory.height();
        this.$asidePaddingTop = parseInt(this.$el.css("padding-top"));
        this.$sideMenuDesktopHeight = this.$('.side-menu-desktop').height();
        this.$sideMenuHeight = this.$sideMenu.height();
        this.$asideContentHeight = this.$asideContent.height();
        this.$asideContentOffsetTop = this.$asideContent.offset().top;

        //Conditions
        if(!this.$menuCategory.length > 0){
            this.$menuCategoryHeight = 0;
        }

        // Side menu desktop
        if($(window).width() > SETTINGS.BREAKPOINTS.CUSTOMMENU_MIN){

            // Become absolute when scrolled beyond bottom of content
            if($(window).scrollTop() + this.$headerHeight + this.$menuCategoryHeight + this.$sideMenuDesktopHeight + this.$asidePaddingTop + Math.min(0,parseInt(this.$sideMenu.css('top'))) >= this.$asideContentOffsetTop + this.$asideContentHeight){
                if (this.$sideMenu.hasClass('fixed')) {
                    this.$sideMenu.removeClass('fixed');
                    this.$sideMenu.css({
                        'top': (this.$asideContentHeight - this.$sideMenuDesktopHeight),
                        'margin-top': 0,
                    });
                }
            }
            // Become fixed while scrolling on the content
            else if(($(window).scrollTop() + this.$headerHeight + this.$menuCategoryHeight) >=  (this.$menuOffset - this.$asidePaddingTop)) {
                this.$sideMenu.addClass('fixed');
                this.$sideMenu.css({
                    'margin-top': this.$headerHeight + this.$menuCategoryHeight + this.$asidePaddingTop
                });

                if(this.previousScroll < $(window).scrollTop()){
                    if(this.$headerHeight + this.$menuCategoryHeight + this.$asidePaddingTop + parseInt(this.$sideMenu.css('top')) + this.$sideMenuHeight >= $(window).height()){
                        this.$sideMenu.css({
                            'top': parseInt(this.$sideMenu.css('top')) - ($(window).scrollTop() - this.previousScroll)
                        });
                    }
                }else{
                    this.$sideMenu.css({
                        'top': Math.min(0, parseInt(this.$sideMenu.css('top')) - ($(window).scrollTop() - this.previousScroll))
                    });

                    // if(this.$headerHeight + this.$menuCategoryHeight + this.$asidePaddingTop + parseInt(this.$sideMenu.css('top')) + this.$sideMenuHeight >= $(window).height()){
                    //
                    // }
                }
            }
            // Become absolute when above the content
            else {
                if (this.$sideMenu.hasClass('fixed')) {
                    this.$sideMenu.removeClass('fixed');
                    this.$sideMenu.css({
                        'top': '',
                        'margin-top': ''
                    });
                    this.$asideContent.css({'padding-top': ''});
                }
            }

            this.previousScroll = $(window).scrollTop();
        }

        // Side menu mobile
        else{
            // Become fixed when scroll
            if(($(window).scrollTop() + this.$headerHeight + parseInt(this.$header.css('top')) + this.$menuCategoryHeight) >=  this.$menuOffset) {
                if (!this.$sideMenu.hasClass('fixed')) {
                    this.$sideMenu.addClass('fixed');
                    this.$sideMenu.css({'top': this.$header.height() - this.$navigationHeader.height() + this.$menuCategoryHeight });

                    let view = this;
                    setTimeout(function(){
                        view.$sideMenu.addClass('animated');
                    }, 0);

                    this.$sidemenuSection.css('padding-top', this.$sideMenuHeight);
                }
            }
            // Become absolute when scroll top
            else {
                if (this.$sideMenu.hasClass('fixed animated')) {
                    this.$sideMenu.removeClass('fixed animated');
                    this.$sideMenu.css({'top' : '0'});
                    this.$sidemenuSection.css('padding-top', '0');
                }
            }

            if(this.$sideMenu.hasClass('fixed')){
                if(this.$header.hasClass('isCollapsed')){
                    this.$sideMenu.css({'top': this.$header.height() - this.$navigationHeader.height() + this.$menuCategoryHeight });
                }
                else{
                    this.$sideMenu.css({'top': this.$header.height() + this.$menuCategoryHeight });
                }
            }


            this.menuCategoryOffset = 0;
            if(this.$menuCategory.length != 0){
                this.menuCategoryOffset = this.$menuCategory.offset().top
            }

            // Make display none when scroll down to the bottom
            if($(window).scrollTop() + this.$headerHeight + this.$menuCategoryHeight > this.$asideContentOffsetTop + this.$asideContentHeight){
                this.$sideMenu.css('display', 'none');
            }
            //or display inline-block when scroll up
            else if(this.menuCategoryOffset + this.$menuCategoryHeight + this.$sideMenuHeight < $('.footer').offset().top){
                this.$sideMenu.css('display', 'inline-block');
            }
        }
    }

    changeMobileMenuState(e, params){

        if(($(window).scrollTop() + this.$header.height() + parseInt(this.$header.css('top')) + this.$menuCategoryHeight) >=  this.$mobileMenuOffset) {
            if(params.isCollapsed){
                $(this.$menuCategory).css({'top': this.$header.height() - this.$navigationHeader.height() + this.$menuCategoryHeight });
            }
            else if(!params.isCollapsed){
                $(this.$menuCategory).css({'top': this.$header.height() + this.$menuCategoryHeight});
            }
        }
    }

    handleBreakpoints(e, params) {
    }
}

